// extracted by mini-css-extract-plugin
export default {"content":"SocietyHomepageDescription_content__ZO+vB","logoImg":"SocietyHomepageDescription_logoImg__cNrdI"};